/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Pricing_Pack_Per_CreditInputs */

const en_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credit`)
};

const de_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / Credit`)
};

const fr_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credit`)
};

const es_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credito`)
};

const it_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credito`)
};

const nl_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credit`)
};

const pl_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / kredyt`)
};

const fi_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / krediitti`)
};

const da_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / credit`)
};

const sv_pricing_pack_per_credit = /** @type {(inputs: Pricing_Pack_Per_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / kredit`)
};

/**
* | output |
* | --- |
* | "{price} / credit" |
*
* @param {Pricing_Pack_Per_CreditInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_pack_per_credit = /** @type {((inputs: Pricing_Pack_Per_CreditInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Pack_Per_CreditInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_pack_per_credit(inputs)
	if (locale === "fr") return fr_pricing_pack_per_credit(inputs)
	if (locale === "es") return es_pricing_pack_per_credit(inputs)
	if (locale === "it") return it_pricing_pack_per_credit(inputs)
	if (locale === "nl") return nl_pricing_pack_per_credit(inputs)
	if (locale === "pl") return pl_pricing_pack_per_credit(inputs)
	if (locale === "fi") return fi_pricing_pack_per_credit(inputs)
	if (locale === "da") return da_pricing_pack_per_credit(inputs)
	if (locale === "sv") return sv_pricing_pack_per_credit(inputs)
	return en_pricing_pack_per_credit(inputs)
});